export default "__VITE_ASSET__DyoMQC5o__"